export default __webpack_public_path__ + "static/media/ClusterIcon.9021d7a1.svg";